const PhoneNumberInput = {
  mounted() {
    const displayInput = this.el.querySelector(
      'input[type="text"], input[type="tel"]',
    )

    displayInput.addEventListener("blur", (e) => {
      e.preventDefault()
      e.stopImmediatePropagation()
      this.pushEventTo(this.el, "blur", { value: displayInput.value })
    })

    this.handleEvent(
      `${this.el.id}:autoformat`,
      ({ formatted_value: formatted_value }) => {
        displayInput.value = formatted_value
        displayInput.dispatchEvent(new Event("input", { bubbles: true }))
      },
    )
  },
}
export { PhoneNumberInput }
